import { motion } from 'motion/react';
import { ReactNode } from 'react';
import { ButtonLoading } from './Loading';

interface FilterActionButtonProps {
  onClick: () => void;
  children: ReactNode;
  variant?: 'primary' | 'secondary';
  loading?: boolean;
}

export function FilterActionButton({
  onClick,
  children,
  variant = 'primary',
  loading = false,
}: FilterActionButtonProps) {
  return (
    <motion.button
      onClick={onClick}
      className="w-full"
      style={{
        paddingTop: '12px',
        paddingBottom: '12px',
        backgroundColor:
          variant === 'primary' ? 'var(--kojo-blue)' : 'transparent',
        color: variant === 'primary' ? 'white' : 'var(--kojo-blue)',
        borderRadius: 'var(--radius-button)',
        fontSize: 'var(--text-base)',
        fontWeight: 'var(--font-weight-semibold)',
        border: variant === 'secondary' ? '1px solid var(--border)' : 'none',
      }}
      whileTap={{ scale: 0.98 }}
      disabled={loading}
    >
      {loading ? <ButtonLoading /> : children}
    </motion.button>
  );
}
